import { render, staticRenderFns } from "./Each_PARA_Show.vue?vue&type=template&id=ccc60012&scoped=true"
import script from "./Each_PARA_Show.vue?vue&type=script&lang=js"
export * from "./Each_PARA_Show.vue?vue&type=script&lang=js"
import style0 from "./Each_PARA_Show.vue?vue&type=style&index=0&id=ccc60012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc60012",
  null
  
)

export default component.exports